<div class="message-view">
  <div class="section">
    <h3>Обычный</h3>
    <div class="messages-container">
      <pa-message severity="error">
        Ошибка
      </pa-message>
      <pa-message severity="info">
        Информация
      </pa-message>
      <pa-message severity="success">
        Успех
      </pa-message>
      <pa-message severity="warn">
        Предупреждение
      </pa-message>
    </div>

    <h3>C иконкой</h3>
    <div class="messages-container">
      <pa-message severity="error" icon="pi pi-info-circle">
        Ошибка
      </pa-message>
      <pa-message severity="info" icon="pi pi-info-circle">
        Информация
      </pa-message>
      <pa-message severity="success" icon="pi pi-info-circle">
        Успех
      </pa-message>
      <pa-message severity="warn" icon="pi pi-info-circle">
        Предупреждение
      </pa-message>
    </div>

    <h3>Закрываемые</h3>
    <div class="messages-container">
      <pa-message severity="error" [closable]="true">
        Ошибка
      </pa-message>
      <pa-message severity="info" [closable]="true">
        Информация
      </pa-message>
    </div>
  </div>
</div>